// extracted by mini-css-extract-plugin
export default {"headerSpaceContainer":"navbar_style_headerSpaceContainer__QxmQq","mobileHeader":"navbar_style_mobileHeader__wZWLS","deskHeader":"navbar_style_deskHeader__fj1gc"};